import React from 'react';
import env from '../env';

interface LinkRedirectProps {
  path?: string;
}

const LinkRedirect: React.FC<LinkRedirectProps> = ({ path = '' }) => {
  window.location.href = env.kindred_website + path;

  return null;
};

export default LinkRedirect;
